import { render, staticRenderFns } from "./Mawb.vue?vue&type=template&id=7ad49835&"
import script from "./Mawb.vue?vue&type=script&lang=js&"
export * from "./Mawb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports